import React, { Component } from 'react';
import Login from './Login';
import Home from './Home';
import { checkAuth, isStaging } from './ApiUtils';

class App extends Component {
    constructor(props) {
        super(props);
        if(!isStaging) {
            console.log = () => {};
        }
        this.state = { isAuth: isStaging };
    }

    componentDidMount() {
        checkAuth(response => {
            console.log('response=',response);
            if(response&&response.auth) {
                this.setState({ isAuth: response.auth });
            }
        })
    }

    render() {
        if(this.state.isAuth) {
            return <Home />
        }
        return <Login />;
    }
}

export default App;